import FavouritesOrdersGrid from './FavouritesOrdersGrid'

export default FavouritesOrdersGrid;